import React from "react";
import { Col, Container, Row } from "reactstrap";
import s from "../common.scss";
import withStyles from "isomorphic-style-loader/withStyles";

interface WizardFormStepProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  className?: string;
  fillHeight?: boolean;
}

const WizardFormStep: React.FC<WizardFormStepProps> = ({
  title,
  subtitle,
  children,
  className,
  fillHeight = true,
}) => {
  return (
    <Row
      className={`${fillHeight ? "h-100" : ""} ${className || s.formContainer}`}
    >
      <Row className="justify-content-center">
        <Col md="12" className="text-center">
          <h2 className={s.title}>{title}</h2>
          <p className={s.subtitle}>{subtitle}</p>
        </Col>
      </Row>
      {children}
    </Row>
  );
};

export default withStyles(s)(WizardFormStep);
